import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft, BarChart3, Settings } from 'lucide-react';
import Layout from '../components/Layout';
import PageHeader from '../components/PageHeader';
import { useTheme } from '../contexts/ThemeContext';
import { useAuth } from '../contexts/AuthContext';
import MetasDashboard from '../components/MetasDashboard';
import MetasConfig from '../components/MetasConfig';

const Metas = () => {
  const { darkMode } = useTheme();
  const { user } = useAuth();
  const navigate = useNavigate();
  const clienteId = user?.cliente_id;

  const [activeTab, setActiveTab] = useState('dashboard');

  return (
    <Layout>
      <div className="space-y-5">
        {/* Header com botão voltar e tabs integradas */}
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-3">
            <button
              onClick={() => navigate('/whatsapp-groups')}
              className={`p-1.5 rounded-md ${darkMode ? 'hover:bg-zinc-700 text-gray-400' : 'hover:bg-gray-100 text-gray-500'}`}
              title="Voltar para Grupos"
            >
              <ArrowLeft size={18} />
            </button>
            <div>
              <h1 className={`text-lg font-bold ${darkMode ? 'text-white' : 'text-gray-900'}`}>Metas</h1>
              <p className={`text-xs ${darkMode ? 'text-gray-400' : 'text-gray-500'}`}>Acompanhe e configure metas por fases</p>
            </div>
          </div>

          {/* Tabs como botões de ícone */}
          <div className={`flex rounded-lg border p-0.5 ${darkMode ? 'border-gray-700 bg-zinc-800' : 'border-gray-200 bg-gray-100'}`}>
            <button
              onClick={() => setActiveTab('dashboard')}
              className={`flex items-center gap-1.5 px-3 py-1.5 text-xs font-medium rounded-md transition-all ${
                activeTab === 'dashboard'
                  ? 'bg-blue-600 text-white shadow-sm'
                  : darkMode ? 'text-gray-400 hover:text-white' : 'text-gray-600 hover:text-gray-900'
              }`}
            >
              <BarChart3 size={13} /> Dashboard
            </button>
            <button
              onClick={() => setActiveTab('configurar')}
              className={`flex items-center gap-1.5 px-3 py-1.5 text-xs font-medium rounded-md transition-all ${
                activeTab === 'configurar'
                  ? 'bg-blue-600 text-white shadow-sm'
                  : darkMode ? 'text-gray-400 hover:text-white' : 'text-gray-600 hover:text-gray-900'
              }`}
            >
              <Settings size={13} /> Configurar
            </button>
          </div>
        </div>

        {/* Conteúdo */}
        {activeTab === 'dashboard' && (
          <MetasDashboard clienteId={clienteId} onNavigateConfig={() => setActiveTab('configurar')} />
        )}
        {activeTab === 'configurar' && (
          <MetasConfig clienteId={clienteId} />
        )}
      </div>
    </Layout>
  );
};

export default Metas;
